// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { makeHandlerChainAwaitable, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    CreatePriceBreak,
    ValidatePriceBreaks,
} from "@insite/client-framework/Store/Pages/RfqQuoteDetails/Handlers/AddPriceBreak";
import validatePriceBreaks from "@insite/client-framework/Store/Pages/RfqQuoteDetails/Handlers/ValidatePriceBreaks";
import { getPriceBreaksForCurrentQuoteLine } from "@insite/client-framework/Store/Pages/RfqQuoteDetails/RfqQuoteDetailsSelectors";
import { BreakPriceRfqModel } from "@insite/client-framework/Types/ApiModels";

export const XngValidatePriceBreaks: any = async (props: any) => {
    const isValid = await makeHandlerChainAwaitable(validatePriceBreaks)({
        isFixedQty: props.parameter.isFixedQty,
        minQty: props.parameter.minQty,
    })(props.dispatch, props.getState);
    if (!isValid) {
        return false;
    }
};

export const XngCreatePriceBreak: any = (props: any) => {
    const priceBreaks = getPriceBreaksForCurrentQuoteLine(props.getState());
    if (!priceBreaks) {
        return false;
    }

    const quoteLine = props.getState().pages.rfqQuoteDetails.quoteLineForCalculation!;
    const { isFixedQty, minQty } = props.parameter;
    const updatedPriceBreaks = priceBreaks.slice();
    const newPriceBreak = { price: 0 } as BreakPriceRfqModel;

    if (updatedPriceBreaks.length !== 0) {
        const lastPriceBreak = { ...updatedPriceBreaks[updatedPriceBreaks.length - 1] };
        if (lastPriceBreak.endQty === 0) {
            lastPriceBreak.endQty = lastPriceBreak.startQty;
        } else {
            lastPriceBreak.endQty = Math.round(lastPriceBreak.endQty);
        }
        updatedPriceBreaks[updatedPriceBreaks.length - 1] = lastPriceBreak;

        newPriceBreak.startQty = lastPriceBreak.endQty + 1;
        newPriceBreak.endQty =
            !isFixedQty && minQty !== "" && newPriceBreak.startQty > quoteLine.maxQty ? 0 : quoteLine.maxQty;
    } else {
        newPriceBreak.startQty = 1;
        newPriceBreak.endQty = quoteLine.maxQty;
    }

    updatedPriceBreaks.push(newPriceBreak);
    props.result = { updatedPriceBreaks };
};

replaceInChain(chain, ValidatePriceBreaks, XngValidatePriceBreaks);
replaceInChain(chain, CreatePriceBreak, XngCreatePriceBreak);
